import { ContextualWarning } from 'common/contextual-warning/contextual-warning.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { ArticleList, IArticleItem } from 'components-modules/article-list/article-list.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';
import { IModule } from 'redux-state/layout/types.js';
import { ArticleSwiper } from './article-swiper.js';

export interface IArticlesConfig {
  items: Array<IArticleItem>;
}

export const ArticleListModule = (props: IModule<IArticlesConfig>) => {
  const isLarge = useContext(ColumnLayoutContext) !== '1-column';
  return <ArticleListCore {...props} isLarge={isLarge} />;
};

/** Export for testing */
export const ArticleListCore = ({
  config,
  modulePath,
  isLarge,
  isDrawer,
}: IModule<IArticlesConfig> & { isLarge: boolean }) => {
  const { maintenance, hideContentOnMaintenance, items } = config;
  const showContent = !maintenance || hideContentOnMaintenance === false;

  if (isLarge) {
    return (
      <Tile dataModule="article-list" config={config}>
        <div className="Tile-body">
          <TileBodyHeaderV2 config={config} modulePath={modulePath} isDrawer={isDrawer} />
          <ArticleList items={items} />
        </div>
      </Tile>
    );
  }
  return (
    <div data-module-name="article-list">
      {maintenance && (
        <div className="u-pB-sm">
          <ContextualWarning maintenance={maintenance} />
        </div>
      )}
      {showContent && <ArticleSwiper items={items} />}
    </div>
  );
};
